import * as actions from '../actions/actionTypes';

const defaultState = {
    practitioners: []
};

const authReducer = (state = defaultState, action) => {
    switch (action.type) {
        case actions.FETCHED_PRACTITIONER:
            return {
                ...state,
                practitioners: action.payload
            };
        default:
            return state;
    }
};

export default authReducer;
